import React, { useContext } from 'react';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { connect } from 'react-redux';

import * as actions from '../actions';

import { Header, Sidebar, AlertEvent } from './layout';
import Dashboard from './dashboard/Dashboard';
import * as Organization from './organiazation';
import * as Application from './application';
import * as Gateway from './gateway';
import * as User from './user';
import * as Worker from './worker';
import * as Detector from './detector';
import * as Communicator from './communicator';
import * as Repeater from './repeater';
import * as Message from './message';
import * as MessageMacro from './messageMacro';
import * as Notice from './notice';
import * as NoticeMacro from './noticeMacro';
import * as Event from './event';
import * as Login from './auth';
import './App.css';
import { Box } from '@mui/material';

import AuthContext, { AuthProvider } from '../contexts/authContext';

const Layout = () => {
  const authContext = useContext(AuthContext);

  if (!authContext.isLoggedIn) {
    return <Navigate to="login" replace />;
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <Header />
      <Sidebar />
      <Outlet />
      <AlertEvent />
    </Box>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <Routes>
        <Route exact path="login" element={<Login.Form />} />
        <Route element={<Layout />}>
          <Route exact path="/" element={<Dashboard />} />

          <Route path="users">
            <Route index element={<User.List />} />
            <Route path=":id/update" element={<User.Form />} />
            <Route path="new" element={<User.Form />} />
          </Route>

          <Route path="workers">
            <Route index element={<Worker.List />} />
            <Route path=":id/update" element={<Worker.Form />} />
            <Route path="new" element={<Worker.Form />} />
            <Route path="attendances" element={<Worker.Attendance />} />
          </Route>

          <Route path="messages">
            <Route index element={<Message.List />} />
            <Route path=":id/update" element={<Message.Form />} />
            <Route path="new" element={<Message.Form />} />

            <Route path="macros">
              <Route index element={<MessageMacro.List />} />
              <Route path=":id/update" element={<MessageMacro.Form />} />
              <Route path="new" element={<MessageMacro.Form />} />
            </Route>
          </Route>

          <Route path="notices">
            <Route index element={<Notice.List />} />
            <Route path=":id/update" element={<Notice.Form />} />
            <Route path="new" element={<Notice.Form />} />

            <Route path="macros">
              <Route index element={<NoticeMacro.List />} />
              <Route path=":id/update" element={<NoticeMacro.Form />} />
              <Route path="new" element={<NoticeMacro.Form />} />
            </Route>
          </Route>

          <Route exact path="events" element={<Event.List />} />

          <Route path="organizations">
            <Route index element={<Organization.List />} />
            <Route path=":id/update" element={<Organization.Form />} />
            <Route path="new" element={<Organization.Form />} />
          </Route>

          <Route path="applications">
            <Route index element={<Application.List />} />
            <Route path=":id/update" element={<Application.Form />} />
            <Route path="new" element={<Application.Form />} />
          </Route>

          <Route path="gateways">
            <Route index element={<Gateway.List />} />
            <Route path=":id/update" element={<Gateway.Form />} />
            <Route path="new" element={<Gateway.Form />} />
          </Route>

          <Route path="repeaters">
            <Route index element={<Repeater.List />} />
            <Route path=":devEUI/update" element={<Repeater.Form />} />
            <Route path="new" element={<Repeater.Form />} />
          </Route>

          <Route path="communicators">
            <Route index element={<Communicator.List />} />
            <Route path=":id/update" element={<Communicator.Form />} />
            <Route path="new" element={<Communicator.Form />} />
          </Route>

          <Route path="detectors">
            <Route index element={<Detector.List />} />
            <Route path=":id/update" element={<Detector.Form />} />
            <Route path="new" element={<Detector.Form />} />
            <Route path="events" element={<Detector.Event />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
};

export default connect(null, actions)(App);
